import {FC, useState} from 'react'
import {Assignment} from '@features/assignment/types'
import {useTranslation} from '@/translations/i18n.tsx'
import {formatLocaleDate} from '@/dates.ts'
import {Button} from '@components/ui/button'
import {AssignmentUnscheduleModal} from '@features/assignment/components/assignment-unschedule-modal'

export const AssignmentScheduledDate: FC<{date: Assignment['to_shoot_at']}> = ({date}) => {
    const {t} = useTranslation()
    const [isUnscheduleModalOpen, setIsUnscheduleModalOpen] = useState(false)

    return (
        <>
            <div className="flex flex-col gap-4 items-start text-success-600 text-display-sm [&_h3]:font-medium">
                <div className="flex flex-col gap-1 items-start">
                    <h3>{date ? formatLocaleDate(date, 'EEEE, d MMMM') : '-'}</h3>
                    <p>{date ? formatLocaleDate(date, 'p') : '-'}</p>
                </div>
                <Button variant="tertiary" shape="text" onClick={() => setIsUnscheduleModalOpen(true)}>
                    {t('assignment:unschedule')}
                </Button>
            </div>

            {isUnscheduleModalOpen && <AssignmentUnscheduleModal onClose={() => setIsUnscheduleModalOpen(false)} />}
        </>
    )
}
